import { apiClient } from '@/lib/apiClient';
import type { MutationOptions } from '@/lib/reactQuery';
import type { DateString } from '@/types/api';
import type { Appointment, DeliveryType, RecurrencePattern, SessionType } from '@/types/scheduling';
import { useMutation } from '@tanstack/react-query';

export interface BookAppointmentStudent {
  studentId: number;
  centerId: number;
  enrollmentId: number;
  sessionType: SessionType;
  deliveryType: DeliveryType;
  duration: number;
}

export interface RecurringSettings {
  recurrencePattern: RecurrencePattern;
  endDate: DateString;
}

export interface BookAppointmentBody {
  students: BookAppointmentStudent[];
  isPlan: boolean;
  selectedTimeslot: DateString;
  recurringSettings?: RecurringSettings;
}

export interface BookAppointmentResponse {
  notPossibleAppointments?: { date: DateString }[];
  notBookedAppointments?: { date: DateString }[];
  bookedAppointments?: Appointment[];
}

export const bookAppointment = async (data: BookAppointmentBody): Promise<BookAppointmentResponse> => {
  const response = await apiClient.post<BookAppointmentResponse>('/v1/scheduling/book-appointment-for-students', data);
  return response.data;
};

interface UseBookAppointmentOptions {
  options?: MutationOptions<BookAppointmentResponse, BookAppointmentBody>;
}

export const useBookAppointment = ({ options }: UseBookAppointmentOptions = {}) =>
  useMutation({
    mutationKey: ['bookAppointment'],
    mutationFn: bookAppointment,
    ...options,
  });
